import { render, staticRenderFns } from "./TabTargetPrice.vue?vue&type=template&id=059daa7a&scoped=true"
import script from "./TabTargetPrice.vue?vue&type=script&lang=js"
export * from "./TabTargetPrice.vue?vue&type=script&lang=js"
import style0 from "./TabTargetPrice.vue?vue&type=style&index=0&id=059daa7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059daa7a",
  null
  
)

export default component.exports